import React, { JSX, useState } from 'react'
import './index.scss'
import DownloadSidebarForm from '@Components/Sidebars/DownloadSidebar/DownloadSidebarForm'
import DownloadSidebarSubmitted from '@Components/Sidebars/DownloadSidebar/DownloadSidebarSubmitted'
import { SidebarDownloadType } from '@App/enum/sidebar-download-type'
import ExportCatalogForm from '@Components/Sidebars/DownloadSidebar/DownloadSidebarForm/ExportCatalogForm'
import RoyaltyStatementDownloadForm from '@Components/Sidebars/DownloadSidebar/DownloadSidebarForm/RoyaltyStatementDownloadForm'
import ExportMatchHistoryForm from '@Components/Sidebars/DownloadSidebar/DownloadSidebarForm/MatchHistoryDownloadForm'
import ExportMatchedRecordingsForm from '@Components/Sidebars/DownloadSidebar/DownloadSidebarForm/MatchRecordingsDownloadForm'
import ExportOverclaimsForm from '@Components/Sidebars/DownloadSidebar/DownloadSidebarForm/ExportOverclaimsForm'
import { observer } from 'mobx-react'
import ExportRegistrationHistoryForm from '@Components/Sidebars/DownloadSidebar/DownloadSidebarForm/ExportRegistrationHistoryForm'
import { RegistrationHistoryTabName } from '@App/enum/registration-history-tab-name'

interface DownloadSidebarProps {
    closeSidebar: () => void
    downloadData?: string[]
    sidebarDownloadType: SidebarDownloadType
    registrationHistoryTabName?: RegistrationHistoryTabName
}

const DownloadSidebar = ({
    closeSidebar,
    downloadData,
    sidebarDownloadType,
    registrationHistoryTabName,
}: DownloadSidebarProps) => {
    const [isFormSubmitted, setIsFormSubmitted] = useState(false)

    const determineFormComponent = (): JSX.Element => {
        switch (sidebarDownloadType) {
            case SidebarDownloadType.CatalogExport:
                return <ExportCatalogForm setIsFormSubmitted={setIsFormSubmitted} />
            case SidebarDownloadType.SongwriterCatalogExport:
                return <ExportCatalogForm setIsFormSubmitted={setIsFormSubmitted} songwriterCatalog />
            case SidebarDownloadType.MatchHistoryExport:
                return <ExportMatchHistoryForm setIsFormSubmitted={setIsFormSubmitted} />
            case SidebarDownloadType.MatchedRecordingsExport:
                return <ExportMatchedRecordingsForm setIsFormSubmitted={setIsFormSubmitted} />
            case SidebarDownloadType.OverclaimExport:
                return <ExportOverclaimsForm setIsFormSubmitted={setIsFormSubmitted} />
            case SidebarDownloadType.RoyaltyStatements:
                return (
                    <RoyaltyStatementDownloadForm setIsFormSubmitted={setIsFormSubmitted} downloadData={downloadData} />
                )
            case SidebarDownloadType.RegistrationHistoryExport:
                return (
                    <ExportRegistrationHistoryForm
                        setIsFormSubmitted={setIsFormSubmitted}
                        registrationHistoryTabName={registrationHistoryTabName}
                    />
                )
            default:
                throw new Error('No case established for [props.sidebarDownloadType]')
        }
    }

    return (
        <div className="download-sidebar">
            {!isFormSubmitted ? (
                <>
                    <DownloadSidebarForm
                        formComponent={determineFormComponent()}
                        formSubText={sidebarDownloadType.formText}
                    />
                </>
            ) : (
                <DownloadSidebarSubmitted closeSidebar={closeSidebar} subText={sidebarDownloadType.submittedText} />
            )}
        </div>
    )
}

export default observer(DownloadSidebar)
